import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AUTH_ROLES } from '@core/authentication/auth.roles';
import { AuthService } from '@core/authentication/auth.service';
import { OiqLayoutAccountModel } from '@oiq-layout/layout.models';
import { OiqNotificationButtonComponent } from '@oiq-notification/notifications/notification-button.component';
import { EmailButtonComponent } from '@v2/modules/email-app/components/email-button/email-button.component';
import { map } from 'rxjs';
import { OiqLayoutAccountComponent } from '../account/account.component';
import { OiqLayoutService } from '../layout.service';
import { LogoType, OiqLayoutLogoComponent } from '../logo/logo.component';
import { OiqLayoutSearchComponent } from '../search/search.component';

@Component({
  selector: 'oiq-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    OiqLayoutSearchComponent,
    OiqNotificationButtonComponent,
    OverlayModule,
    OiqLayoutAccountComponent,
    OiqLayoutLogoComponent,
    EmailButtonComponent,
  ],
  host: {
    class: 'oiq-layout-header',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class OiqLayoutHeaderComponent {
  public destroyRef = inject(DestroyRef);
  public layout = inject(OiqLayoutService);
  public auth = inject(AuthService);

  public searchVisible$ = this.auth.cookieChanges$.pipe(
    takeUntilDestroyed(this.destroyRef),
    map(_ => {
      const _roles = this.auth.getUser().roles || [];
      return !_roles
        .map(role => role.name)
        .some(_role => [AUTH_ROLES.SYNDICATOR, AUTH_ROLES.MASTER_SYNDICATOR].includes(_role));
    })
  );
  public searchVisible = toSignal(this.searchVisible$);
  public canSearch = toSignal(this.layout.canSearch$);

  @Input() isImpersonated: boolean = false;
  @Input() brandImg: string | null = '';
  @Input() logoType: LogoType = 'jpeg';
  @Input() account: OiqLayoutAccountModel | null = null;
  @Input() emailAppEnabled: boolean = false;
  @Output() logout = new EventEmitter<void>();
  @Output() searched = new EventEmitter<string>();

  isUserMenuOpen = false;

  burgerMenuClick() {
    this.layout.sidebarToggle();
  }
}
